// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Pn4Kv","reconsiderModal":"Header_reconsiderModal__pQE4P","close":"Header_close__ryN27"};